function CalculatePromotion(Work) {
  let noOfPormotion = 0;
  if (!Work || Work.length === 0) return noOfPormotion;
  const titleList = Work.map(work => work.Title);
  noOfPormotion = new Set(titleList).size;
  return noOfPormotion - 1;
}

export default CalculatePromotion;
